define('presentation/shell/viewModels/onboardingShellViewModel',[
    'settings/settings',
    'businessServices/authentication/sessionAccountInfo',
    'businessServices/authentication/sessionUserInfo',
    'businessServices/events/eventManager',
    'businessServices/onboarding/liveReceptionistOnboardingSingleton',
    'businessServices/router/router',
    'common/promises/promiseFactory',
    'constants/shellNameEnumerations',
    'presentation/welcome/common/onboardingPageIndicatorWidget',
    'presentation/welcome/common/onboardingNavigationManager'
], function(
    /** @type import('settings/settings') */
    _settings
) {
    return function() {
        let self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _sessionAccountInfo = require('businessServices/authentication/sessionAccountInfo');
        const _sessionUserInfo = require('businessServices/authentication/sessionUserInfo');
        const _shellNameEnumerations = require('constants/shellNameEnumerations');
        const _indicatorWidget = require('presentation/welcome/common/onboardingPageIndicatorWidget');
        const _liveReceptionistOnboardingState = require('businessServices/onboarding/liveReceptionistOnboardingSingleton');

        let _eventManager = null;
        let _onboardingNavigationManager = null;

        const _onShellUpdated = (shellName) => {
            if (shellName === _shellNameEnumerations.onboarding) {
                self.childViewModel(self.router.activeItem());
                self.shellIsActive(true);
                _refreshProgress();
            } else {
                self.childViewModel(null);
                self.shellIsActive(false);
            }
        };

        self.router = null;
        self.childViewModel = ko.observable();
        self.shellIsActive = ko.observable(true);

        self.isProgressBarVisible = ko.observable(false);
        self.isFinishLaterVisible = ko.observable(false);
        self.progressPercentage = ko.observable(0);
        self.isProgressComplete = ko.pureComputed(() => self.progressPercentage() === 100);

        const _refreshProgress = () => {
            _indicatorWidget.setIndicator(self.isProgressBarVisible, self.progressPercentage);
            self.isFinishLaterVisible(_indicatorWidget.isFinishLaterVisible());
        };

        const _seedProgress = () => {
            _liveReceptionistOnboardingState.getProgressPercentage()
                .done((progressPercentage) => {
                    self.progressPercentage(progressPercentage);
                    _refreshProgress();
                });
        };

        const _childValue = (name) => {
            const childViewModel = self.childViewModel();
            return childViewModel === null || childViewModel === undefined ?
                undefined :
                ko.unwrap(childViewModel[name]);
        };

        self.isMinContentContainer = ko.pureComputed(() => _childValue('isMinContentContainer') === true);
        self.isCenteredContentContainer = ko.pureComputed(() => _childValue('isCenteredContentContainer') === true);
        self.isCompactContentContainer = ko.pureComputed(() => _childValue('isCompactContentContainer') === true);

        self.onFinishLaterClicked = () => {
            _onboardingNavigationManager.navigateToPreOnboardingPageOrHome();
        };

        self.openMessenger = () => {
            /* jshint ignore:start */
            Genesys('subscribe', 'Database.ready', function() {
                const messagingCustomAttributes = {
                    messaging: {
                        customAttributes: {
                            accountNumber: _sessionAccountInfo.accountNumber(),
                            emailAddress: _sessionUserInfo.emailAddress(),
                            name: _sessionUserInfo.fullName(),
                            environment: _settings.environmentHostName
                        }
                    }
                }
                Genesys('command', 'Database.set', messagingCustomAttributes);

                Genesys("subscribe", "Messenger.ready" , function(o){
                    Genesys('command', 'Messenger.open', {});
                });
            });
            /* jshint ignore:end */
        };

        self.activate = () => {
            self.router = require('businessServices/router/router');
            _eventManager = require('businessServices/events/eventManager');

            const OnboardingNavigationManagerConstructor = require('presentation/welcome/common/onboardingNavigationManager');
            _onboardingNavigationManager = new OnboardingNavigationManagerConstructor();

            self.childViewModel(self.router.activeItem());

            return _initialize();
        };

        const _initialize = () => {
            if (self.childViewModel() !== null){
                self.childViewModel().parent = self;
            }

            _eventManager.subscribeShellUpdated(_onShellUpdated);

            _seedProgress();

            return _promiseFactory.wait();
        };
    };
});
